import { render, staticRenderFns } from "./ModattaLanguageDropdown.vue?vue&type=template&id=661a8cf0"
import script from "./ModattaLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ModattaLanguageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports